export const chargepointTotal = {
	total: '62,000',
};
